import list from 'src/modules/documentCategory/list/documentCategoryListReducers';
import form from 'src/modules/documentCategory/form/documentCategoryFormReducers';
import view from 'src/modules/documentCategory/view/documentCategoryViewReducers';
import destroy from 'src/modules/documentCategory/destroy/documentCategoryDestroyReducers';
import importerReducer from 'src/modules/documentCategory/importer/documentCategoryImporterReducers';
import {combineReducers} from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
